module.exports = __webpack_public_path__ + "svg/hero2.70ef8c6.svg";